import { useCallback } from "react";
import { ErrorBoundary, FallbackProps } from "react-error-boundary";

import ErrorTriggered from "../ErrorTriggered";
import Fallback from "../Fallback";

interface ErrorWrapperProps {
  fullPage?: boolean;
  fullLayout?: boolean;
  children: React.ReactNode;
  error?: any;
  withImage?: boolean;
  size?: "lg" | "md";
}

const ErrorWrapper = ({
  fullPage,
  fullLayout,
  children,
  error,
  withImage = false,
  size = "lg",
}: ErrorWrapperProps) => {
  const renderFallback = useCallback(
    (props: FallbackProps) => {
      return (
        <Fallback
          {...props}
          size={size}
          customError={error}
          fullPage={fullPage}
          fullLayout={fullLayout}
          withImage={withImage}
        />
      );
    },
    [error, fullLayout, fullPage, size, withImage]
  );

  return (
    <ErrorBoundary FallbackComponent={renderFallback}>
      <ErrorTriggered error={error}>{children}</ErrorTriggered>
    </ErrorBoundary>
  );
};

export default ErrorWrapper;
